// extracted by mini-css-extract-plugin
export default {"wrapper":"Item_wrapper__5Y8Wc","icon":"Item_icon__Gi0+w","text":"Item_text__u7AtO","link":"Item_link__ZU1sp"};